/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, ListGroup, Row, Col, Badge } from 'react-bootstrap';
import * as S from './styles';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import { ExternalLinkIcon } from '@heroicons/react/solid';

export interface IOptionsProps {
  percent?: string;
  title?: string[];
  value?: string;
}

export interface IListItemsProps {
  title: string;
  description?: string;
  listItems?: IOptionsProps[];
}

function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

function start_and_end(str) {
  if (str.length > 25) {
    return (
      str.substr(0, 10) + '.....' + str.substr(str.length - 10, str.length)
    );
  }
  return str;
}

const getFirstLetterOfEachWord = (text) => text?.match(/\b\w/g).join('');

export const ListItemsComp = ({
  title,
  description,
  listItems,
}: IListItemsProps) => {
  const { bp } = useViewport();
  const _renderSubTitleIf = () => {
    if (description) {
      return <p> {description} </p>;
    }
  };

  const _renderTitle = () => {
    if (title) {
      return (
        <Card.Header className="border-bottom">
          <h2 className="fs-5 fw-bold mb-0">{title}</h2>
          {_renderSubTitleIf()}
        </Card.Header>
      );
    }
  };

  const _renderPercent = (payout: any) => {
    if (payout?.percent) {
      return (
        <Col xs="auto">
          <Badge bg="secondary" className="m-0 p-2">
            {payout?.percent}
          </Badge>
        </Col>
      );
    }
    return null;
  };
  const _renderTitleIf = (payout: any) => {
    if (
      payout?.title &&
      !Array.isArray(payout?.title) &&
      typeof (payout?.title === 'string')
    ) {
      return (
        <Col xs="12" md="auto" className="px-0">
          <h4 className="fs-6 text-dark mb-0 w-100">{payout?.title}</h4>
        </Col>
      );
    }
    if (Array.isArray(payout?.title)) {
      return (
        <Col xs="12" md="auto" className="px-0">
          {payout?.title?.map((str: string, index: number) => {
            return (
              <>
                <h4 className="fs-6 text-dark mb-0 w-100" key={`list-${index}`}>
                  {str}
                </h4>
                <br />
              </>
            );
          })}
        </Col>
      );
    }
    return null;
  };

  const _renderValueIfLink = (subtitle: string) => {
    if (subtitle) {
      if (isValidHttpUrl(subtitle)) {
        return (
          <a href={subtitle} target={'_blank'}>
            {start_and_end(subtitle)}
            <ExternalLinkIcon className="icon icon-xs ms-2" />
          </a>
        );
      }
      return subtitle;
    }
    return '';
  };

  const _renderValueIf = (payout: any) => {
    if (payout?.value) {
      return (
        <Col
          xs="12"
          md="auto"
          className={bp === 'xs' ? 'text-start px-0' : 'text-end'}
        >
          <span className="fs-6 fw-bolder text-dark">
            {_renderValueIfLink(payout?.value)}
          </span>
        </Col>
      );
    }
  };
  const _renderCardBody = () => {
    if (listItems) {
      return (
        <Card.Body className="py-0">
          <ListGroup className="list-group-flush">
            {listItems?.map((payout, index) => (
              <ListGroup.Item
                key={`option-item-${index}`}
                className="bg-transparent border-bottom py-3 px-0"
              >
                <Row
                  className="align-items-center"
                  style={bp === 'xs' ? {} : S.RowStyle}
                >
                  {_renderPercent(payout)}
                  {_renderTitleIf(payout)}
                  {_renderValueIf(payout)}
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      );
    }
  };
  return (
    <Card border="0" className="shadow">
      {_renderTitle()}
      {_renderCardBody()}
    </Card>
  );
};

ListItemsComp.defaultProps = {
  listItems: [],
};
